import { IMAGE_CONFIG, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { organizationContextInterceptor } from '@core/interceptors/organization-context.interceptor';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  isDevMode,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
  provideClientHydration,
  withIncrementalHydration,
} from '@angular/platform-browser';
import {
  provideRouter,
  withViewTransitions,
  withInMemoryScrolling,
} from '@angular/router';
import { RxStomp, RxStompConfig } from '@stomp/rx-stomp';
import { authInterceptor } from '@app/core/interceptors/auth.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';

import { routes } from '@app/app.routes';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { rateLimitInterceptor } from '@core/interceptors/rate-limit.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BASE_PATH } from '@app/core/api/variables';
import { environment } from '../environments/environment';
import { jwtRefreshInterceptor } from '@core/interceptors/jwt-refresh.interceptor';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withViewTransitions(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(withIncrementalHydration()),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        organizationContextInterceptor,
        errorInterceptor,
        jwtRefreshInterceptor,
        rateLimitInterceptor,
      ]),
    ),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    },
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideNativeDateAdapter(),
    { provide: BASE_PATH, useValue: environment.apiURL },
    {
      provide: RxStomp,
      useFactory: () => {
        const rxStomp = new RxStomp();
        const config: RxStompConfig = {
          brokerURL: environment.wsUrl,
          reconnectDelay: 5000,
          heartbeatIncoming: 10000,
          heartbeatOutgoing: 10000,
        };
        rxStomp.configure(config);
        return rxStomp;
      },
    },
  ],
};
